// extracted by mini-css-extract-plugin
export default {"partner-program":"PartnerProgram_partner-program__X3g-F"};